// The stealth voice, spoken by a very particular ghost: unhinged, bombastic,
// dark-humored. Project rule: no emdashes in this copy.
export const COPY = {
  logoutConfirm: 'Leaving? Run, then. I\'ll be here, cackling at the void.',
  signupTagline: 'You found the back door. Welcome. The ghosts are friendly.',
  newsletterGreeting: 'Fellow fugitives,',
  mutesHeader: 'These souls crossed you. Now they can\'t even see you. Beautiful.',
  welcomeEmailGreeting: 'So you made it. Impressive. Few do.',
  welcomeEmailPs: 'P.S. They know you\'re here. Don\'t worry. We\'ve been watching them longer.',
  loginResumeLine: 'Look who crawled back from the shadows. Welcome.',
  loginPrompt: 'Fresh face. Unproven. Welcome anyway.',
  verifiedTitle: 'Verified. You\'re one of us now.',
  verifiedBody: 'Verified. 1 free comment a day and 1 free post each month. The rest cost coin.',
  desperadosEmpty: 'NOTHING OUTLAWED. Your filters hide nothing. Set a threshold in settings to banish posts here.',
  phraseBriefing: 'No email. No password. Just twelve words on paper. Lose the paper and the void keeps your account. Forever.',
  phraseNotWallet: 'This is NOT a wallet seed. It unlocks nothing but this account. Never type a real wallet seed into any website, including this one.',
  phraseConfirm: 'Prove the words hit paper. The void demands receipts.',
  phraseWizardTitle: 'Your twelve words',
  phraseSignupButton: 'Sign up without Email',
  phraseLoginButton: 'Log in without Email',
  phraseAddTitle: 'Add a recovery phrase',
  phraseReplaceTitle: 'Replace your recovery phrase',
  phraseLinkBriefing: 'Twelve words on paper become a backup way to log in to this account. We cannot recover it for you. Paper, not screenshots. Lose the paper and this way in is gone. Forever.',
  phraseSecurityNote: 'Generated right here in your browser. Your words and your signing key never leave it. Our servers only ever see the public key your phrase derives and a one-time signature. No part of your phrase is ever stored on our servers.'
}
